import React from "react";
import Chart from "react-apexcharts";
import ReactApexChart from "react-apexcharts";

const RadialBarChart = ({ dataColors, series, labels, totalLabel }) => {
    const options = {
        chart: {
          type: "donut",
        },
        colors: dataColors,
        labels: labels,
        plotOptions: {
          pie: {
            donut: {
              size: "65%", // Controls the inner circle size
              background: "transparent",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: totalLabel,
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "#333",
                  formatter: () => "50%", // Dynamic percentage
                },
              },
            },
          },
        },
        stroke: {
          width: 10, // Adjust segment separation width
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        stroke: {
            width: 0, // Adjust segment separation width
          },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
            },
          },
        ],
      };
      

  return (
    <div>
     <ReactApexChart
        options={options}
        series={series}
        type="donut"
        height={300}
      />
    </div>
  );
};

export default RadialBarChart;
